import { memo, ReactNode } from 'react';
import { ThemeProvider } from './ThemeProvider';
import { Toaster } from '@/components/ui/sonner';
import AuthProvider from '@/providers/AuthProvider';

export function Layout({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider defaultTheme="light">
      <AuthProvider>
        {children}
        <Toaster
          richColors
        />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default memo(Layout);
